import * as Styles from './PageEmptyState.styles';

type Props = {
  title: string;
  description?: string;
  className?: string;
};

const PageEmptyState = ({ className, title, description }: Props): JSX.Element => (
  <Styles.Container className={className}>
    <Styles.Title>{title}</Styles.Title>
    {description && <Styles.Description>{description}</Styles.Description>}
  </Styles.Container>
);

export default PageEmptyState;
